const ISO_RE = /^(\d{4})-(\d{2})-(\d{2})$/

export function parseIsoStrict(s: string): Date | null {
  const m = ISO_RE.exec(s)
  if (!m) return null
  const [y, mo, d] = [+m[1], +m[2], +m[3]]
  const date = new Date(y, mo - 1, d)
  if (date.getFullYear() !== y || date.getMonth() !== mo - 1 || date.getDate() !== d) return null
  return date
}

export function parseUeProWoche(zeitlUmfangWoche: string): number | null {
  const m = /=\s*(\d+)\s*UE\s*$/i.exec(zeitlUmfangWoche.trim())
  if (!m) return null
  const n = parseInt(m[1], 10)
  return n > 0 ? n : null
}

export function realUe(massnahmeUe: number, maxUe: number): number {
  return Math.min(massnahmeUe, maxUe)
}

export function teilnahmeWochen(
  massnahmeUe: number,
  maxUe: number,
  zeitlUmfangWoche: string,
): number | null {
  const proWoche = parseUeProWoche(zeitlUmfangWoche)
  if (proWoche == null) return null
  const ue = realUe(massnahmeUe, maxUe)
  if (!(ue > 0)) return null
  return Math.ceil(ue / proWoche)
}

export function teilnahmeEnde(beginnIso: string, wochen: number): string | null {
  const beginn = parseIsoStrict(beginnIso)
  if (!beginn || wochen < 1) return null
  const ende = new Date(beginn.getFullYear(), beginn.getMonth(), beginn.getDate() + wochen * 7 - 1)
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${ende.getFullYear()}-${pad(ende.getMonth() + 1)}-${pad(ende.getDate())}`
}

export function spanWochen(beginnIso: string, endeIso: string): number | null {
  const beginn = parseIsoStrict(beginnIso)
  const ende = parseIsoStrict(endeIso)
  if (!beginn || !ende) return null
  const days = Math.round((ende.getTime() - beginn.getTime()) / 86_400_000) + 1
  if (days < 1) return null
  return days / 7
}

export function formatWochen(wochen: number): string {
  const days = Math.round(wochen * 7)
  const weeks = Math.floor(days / 7)
  const rest = days % 7
  const weeksPart = weeks === 1 ? '1 Woche' : `${weeks} Wochen`
  const restPart = rest === 1 ? '1 Tag' : `${rest} Tage`
  if (weeks > 0 && rest > 0) return `${weeksPart} und ${restPart}`
  if (weeks > 0) return weeksPart
  return restPart
}
